import { render, staticRenderFns } from "./InputPad.vue?vue&type=template&id=84b3e5f0&"
import script from "./InputPad.vue?vue&type=script&lang=js&"
export * from "./InputPad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports